export default "__VITE_ASSET__DVO0KyRq__"